export const defaultActiveMenuStyles = {
  shaped: false,
  rounded: false,
  flat: false,
};

export default {
  show: true,
  miniVariant: false,
  isRight: false,
  activeMenuStyle: {
    shaped: true,
    rounded: false,
    flat: false,
  },
  dense: true,
};
